/**
 * Feature flags for Meridian
 * Local implementation of feature flag system
 */

/**
 * Check if a feature is enabled for Meridian
 * @param featureName - The name of the feature to check
 * @returns boolean - Whether the feature is enabled
 */
export const isFeatureEnabled = (featureName: string): boolean => {
  // Check environment variable first
  const envVar = process.env[`NEXT_PUBLIC_FEATURE_${featureName}`];
  if (envVar !== undefined) {
    return envVar === 'true' || envVar === '1';
  }
  
  // Default feature flags
  const defaultFlags: Record<string, boolean> = {
    'MERIDIAN_SHARE_CHAT': true,
    'MERIDIAN_VOICE_READING': false,
    'MERIDIAN_BUSINESS_INFO': false,
  };
  
  return defaultFlags[featureName] ?? false;
};

/**
 * Check if the share chat feature is enabled
 * @returns boolean - Whether share chat is enabled
 */
export const isShareChatEnabled = (): boolean => {
  return isFeatureEnabled('MERIDIAN_SHARE_CHAT');
};
















